import React from "react";
import { useEffect } from "react";
import baozhigou from "./baozhigou.jpg";
class HedgedDetail extends React.Component {
  render() {
    return (
      <div style={{ minHeight: "100vh", background: "#f3f4f5" }}>
        <img src={baozhigou} style={{ width: "100%" }} />
      </div>
    );
  }
}

export default HedgedDetail;



// WEBPACK FOOTER //
// ./src/staticPage/hedged/index.js